// Tiny formatting helpers with no external deps to keep the bundle small.

export function formatDateTime(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  })
}

export function formatDate(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString()
}

export function cx(...parts) {
  return parts.filter(Boolean).join(' ')
}

export function firstError(err, fallback = 'Something went wrong') {
  // Form-level validation errors are commonly raised as plain strings —
  // surface them verbatim instead of falling through to the generic
  // network-error fallback.
  if (typeof err === 'string') return err
  const r = err?.response?.data
  if (!r) return err?.message || fallback
  if (typeof r === 'string') return r
  // Phase 1 introduced a normalised envelope: { error: { code, message, details } }
  if (r.error && typeof r.error === 'object') {
    // The wrapped error envelope is { code, message, details }. The
    // message is often a generic header like "Validation failed." while
    // the actionable text lives in `details`. Surface the most specific
    // string we can find.
    const det = r.error.details
    if (det && typeof det === 'object' && !Array.isArray(det)) {
      const firstField = Object.keys(det)[0]
      const val = firstField && det[firstField]
      if (Array.isArray(val) && val.length) {
        return firstField === 'non_field_errors'
          ? String(val[0])
          : `${firstField}: ${val[0]}`
      }
      if (typeof val === 'string') {
        return firstField === 'non_field_errors' ? val : `${firstField}: ${val}`
      }
    }
    if (Array.isArray(det) && det.length && typeof det[0] === 'string') return det[0]
    if (r.error.message) return r.error.message
  }
  if (r.detail) return r.detail
  if (r.non_field_errors?.[0]) return r.non_field_errors[0]
  if (Array.isArray(r)) return r[0]
  const firstField = Object.keys(r)[0]
  const val = firstField && r[firstField]
  if (Array.isArray(val)) return `${firstField}: ${val[0]}`
  if (typeof val === 'string') return `${firstField}: ${val}`
  return fallback
}

// Extract the X-Request-ID associated with an error (or axios response).
// The api client attaches err.requestId in its response interceptor.
// We also check response.headers as a defensive fallback for callers that
// bypass the shared axios instance.
export function requestIdOf(err) {
  if (!err) return null
  if (err.requestId) return err.requestId
  const h = err.response?.headers
  if (h) return h['x-request-id'] || h['X-Request-ID'] || null
  return null
}

// Normalize paginated DRF responses and raw arrays into a plain array.
export function unwrapList(data) {
  if (Array.isArray(data)) return data
  if (data && Array.isArray(data.results)) return data.results
  return []
}

export function statusColor(status) {
  switch ((status || '').toLowerCase()) {
    case 'draft': return 'text-amber-600 bg-amber-50 border-amber-200'
    case 'submitted': return 'text-emerald-700 bg-emerald-50 border-emerald-200'
    case 'amended': return 'text-sky-700 bg-sky-50 border-sky-200'
    case 'pending':
    case 'routed': return 'text-slate-600 bg-slate-50 border-slate-200'
    case 'accepted':
    case 'in_progress': return 'text-indigo-700 bg-indigo-50 border-indigo-200'
    case 'dispensed':
    case 'completed': return 'text-emerald-700 bg-emerald-50 border-emerald-200'
    case 'cancelled':
    case 'rejected': return 'text-rose-700 bg-rose-50 border-rose-200'
    default: return 'text-slate-600 bg-slate-50 border-slate-200'
  }
}
